document.addEventListener('DOMContentLoaded', () => {
    const selector = '#rcp_register';
    if ((document.querySelector(selector) !== null)) {
        import('./register').then(({ registerMap }) => {
            registerMap();
        });
        import('./register-select').then(({ registerSelect }) => {
            registerSelect();
        });
        import('./register-observer').then(({ registerObserver }) => {
            registerObserver();
        });
        import('./remove-fields').then(({ removeFields }) => {
            removeFields();
        });
    }
});
